var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('lodash'),
    get = _require.get;

var WTError = require('./error');

var logger = require('./config/logger');

var authorize = require('./authorize');

var request = require('./request');

var _require2 = require('./boards'),
    createBoard = _require2.createBoard,
    findBoard = _require2.findBoard;

var _require3 = require('./transfers'),
    createTransfer = _require3.createTransfer,
    findTransfer = _require3.findTransfer;

var _require4 = require('./boards/actions'),
    addFilesToBoard = _require4.addFilesToBoard,
    addLinksToBoard = _require4.addLinksToBoard,
    getFileUploadURLToBoard = _require4.getFileUploadURLToBoard,
    completeFileUploadToBoard = _require4.completeFileUploadToBoard;

var _require5 = require('./transfers/actions'),
    completeFileUploadToTransfer = _require5.completeFileUploadToTransfer,
    finalizeTransfer = _require5.finalizeTransfer;

module.exports =
/*#__PURE__*/
function () {
  var _createWTClient = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(apiKey) {
    var options,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
              logger: {}
            };

            if (apiKey) {
              _context.next = 3;
              break;
            }

            throw new WTError('No API Key provided');

          case 3:
            logger.setLoggerLevel(get(options, 'logger.level', 'info'));
            request.apiKey = apiKey;
            _context.next = 7;
            return authorize();

          case 7:
            request.jwt = _context.sent.token;
            request.configure(options);
            return _context.abrupt("return", {
              authorize: authorize,
              board: {
                create: createBoard,
                find: findBoard,
                addFiles: addFilesToBoard,
                addLinks: addLinksToBoard,
                getFileUploadURL: getFileUploadURLToBoard,
                completeFileUpload: completeFileUploadToBoard
              },
              transfer: {
                create: createTransfer,
                find: findTransfer,
                getFileUploadURL: getFileUploadURLToTransfer,
                completeFileUpload: completeFileUploadToTransfer,
                finalize: finalizeTransfer
              }
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function createWTClient(_x) {
    return _createWTClient.apply(this, arguments);
  }

  return createWTClient;
}();